import { Secretaria } from "./secretaria.interface";
import { Usuario } from "./usuario.interface";

export class Enfermeiro implements Usuario {
  id?: string;
  primeiro_nome: string;
  sobrenome: string;
  idade: string | Date;
  endereco: string;
  cidade: string;
  estado: string;
  telefone: string;
  whatsapp?: string;
  name_instagram?: string;

  email: string;
  tipo_usuario: 'enfermeiro'; 
  url?: string;
  cbo?: string;
  cns?: string;
  cns_tipo?: string;
  cns_validade?: Date;
  ativado: boolean;
  bloqueado: boolean;
  n_pacientes?: number;
  proxima_consulta?: any;
  maximo_cartoes?: number;
  cartoes_usados?: number;
  secretarias?: Array<Secretaria>
  orgs?: Array<{ id: string, nome: string, instituicao_publica: 'S' | 'N' }>;
  unidades?: Array<{ id: string, nome: string, tipo: 'AMB'| 'CS'| 'CLI'| 'HE'| 'HG'| 'PA'| 'PS'| 'UBS'| 'USF'| 'UDADT'| 'UM' }>;

  static create(enfermeiro: {
    primeiro_nome: string,
    sobrenome: string,
    idade: string,
    endereco: string,
    cidade: string,
    estado: string,
    telefone: string,
    whatsapp?: string;
    name_instagram?: string;
    cbo?: string,
    cns?: string;
    cns_tipo?: string
    cns_validade?: Date;
    email: string,
    ativado: boolean,
    bloqueado: boolean,
    maximo_cartoes: number
    org?: string;
    org_name?: string;
    unidade?: string;
    unidade_name?: string;
  }) {
    return {
      primeiro_nome: enfermeiro.primeiro_nome,
      sobrenome: enfermeiro.sobrenome,
      idade: enfermeiro.idade,
      endereco: enfermeiro.endereco,
      cidade: enfermeiro.cidade,
      estado: enfermeiro.estado,
      telefone: enfermeiro.telefone,
      whatsapp: enfermeiro.whatsapp,
      name_instagram: enfermeiro.name_instagram,
      cbo: enfermeiro.cbo,
      cns: enfermeiro.cns,
      cns_tipo: enfermeiro.cns_tipo,
      cns_validade: enfermeiro.cns_validade,
      email: enfermeiro.email,
      ativado: false,
      bloqueado: false,
      tipo_usuario: 'enfermeiro',
      n_pacientes: 0,
      maximo_cartoes: enfermeiro.maximo_cartoes,
      org: enfermeiro.org,
      org_name: enfermeiro.org_name,
      unidade: enfermeiro.unidade,
      unidade_name: enfermeiro.unidade_name
    };
  }

  static createEmpty(): Enfermeiro {
    return {
      primeiro_nome: '',
      sobrenome: '',
      idade: '',
      endereco: '',
      cidade: '',
      estado: '',
      telefone: '',
      whatsapp: '',
      name_instagram: '',
      cbo: '',
      cns: '',
      cns_tipo: '',
      cns_validade: undefined,
      email: '',
      ativado: false,
      bloqueado: false,
      tipo_usuario: 'enfermeiro',
      n_pacientes: 0,
      maximo_cartoes: 0,
    };
  }
}
